export default __webpack_public_path__ + "static/media/YAS0240.34I-27724_-16882_0.fe44024f.jpg";